module.exports = "/_next/static/images/ticketSearch-0f5b808eea7df175ec6f2bf2ddbb5a5b.svg";